import React from 'react'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import { CardType } from '../../enums'
import { useBidderStatsQuery } from '../../generated/graphql'
import type { BasicWidgetProps } from '../../types'

const DAYS_AGO = 6
const SEARCH_STRING = `saledate:${DAYS_AGO}`

const BiddersThisWeek = ({
    config: { text = 'Bidders', secondaryText = 'In the last 7 days' },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useBidderStatsQuery({
        variables: {
            searchString: SEARCH_STRING,
            searchStringOnline: `${SEARCH_STRING} biddertype:online`,
        },
    })

    const onlineBidders = data?.auction?.onlinebidders?.bidderCount || 0
    const totalBidders = data?.auction?.totalbidders?.bidderCount || 0

    let biddersOnlinePercent = 0
    if (totalBidders && onlineBidders && totalBidders > 0 && onlineBidders > 0) {
        biddersOnlinePercent = Math.round((onlineBidders / totalBidders) * 100)
    }

    const biddersOnlineCountLabel = onlineBidders ? `${onlineBidders} online (${biddersOnlinePercent}%)` : ''

    return (
        <SingleNumberWidget
            cardType={CardType.CUSTOMER}
            action={{
                text: 'View Bidder Stats',
                link: `/bidderstats`,
            }}
            loading={loading}
            number={totalBidders || '--'}
            secondaryText={secondaryText}
            text={text}
            text2={biddersOnlineCountLabel}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default BiddersThisWeek
